$(function () {

	if ($('.service-review-list').length > 0 && !is_tablet) {
		$('.service-review-list').owlCarousel({
			items: 2,
			loop: true,
			margin: 64,
			nav: true,
			smartSpeed: 500,
			dots: false,
			slideTransition: "cubic-bezier(0.65,0.05,0.36,1)",
			responsive: {
				0: {
					items: 1.7,
					margin: 8,
					nav: false
				},
				1023: {
					margin: 26,
				},
				1281: {
					margin: 64,
					items: 2,
				},
			}
		});
	}

	$(window).on('scroll', function () {
		scroll_service_init($(window), false);
	});

	scroll_service_init($(window), true);

});

function scroll_service_init(scroll_block, first) {
	if ($('.img-cols-itm-content').length < 3 || (!is_desktop) || is_tablet_big || !scroll_block) {
		return;
	}

	let scroll = scroll_block.scrollTop() + scroll_block.height(),
		block = $('.img-cols-block'),
		center = scroll_block.outerWidth(true) / 2,
		scroll_start = block.offset().top,
		scroll_end = scroll_start + block.outerHeight(true),
		left_speed = -0.2,
		left_offset = ($('.img-cols-itm').outerHeight() / 3),
		right_speed = 0.05,
		y = scroll - scroll_start;


	if (scroll_block.scrollTop() > scroll_end) {
		y = block.outerHeight(true);
	}


	if (scroll > scroll_start || first) {

		$('.img-cols-itm:not(.animate)').each(function () {
			let left = $(this).offset().left,
				itm = $(this).find('.img-cols-itm-content'),
				res = 0;

			if (left < center) {
				res = y * left_speed + left_offset;
			} else {
				res = y * right_speed;
			}

			gsap.to(itm, {y: res});
		});

	}
}
